import React, { SVGProps } from 'react';
const expandLessFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="m16 11.295-7.619 7.619 1.79 1.79L16 14.888l5.829 5.816 1.79-1.79z" /></svg>;
export default expandLessFilled;